<template>
    <div class="modal-wrapper" v-if="value">
        <div class="modal-bg" @click.self="$emit('input', false)"></div>
        <div class="modal-card card">
            <div class="modal-header">
                <h3 class="h5 m-0">{{ headerText }}</h3>
                <button @click="$emit('input', false)" class="icon-x"></button>
            </div>
            <div class="modal-content">
                <slot name="modal-body" />
            </div>
            <div class="modal-footer" v-show="showFooter">
            <slot name="modal-footer"/>
      </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        value: Boolean,
        headerText: String,
        merges: Object,
        showFooter: {
            type: Boolean,
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";

.modal-wrapper {
    bottom: 0px;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    z-index: 20;

    .modal-bg {
        position: absolute;
        top: 0;
        height: 100vh;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 3;
    }

    .modal-card {
        @include responsive("sm") {
            width: 90vw;
            min-width: unset;
        }

        min-width: 400px;
        max-width: 80%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
        left: 50%;
        min-height: 200px;
        z-index: 4;

        .modal-header {
            border: none;
            display: flex;
            justify-content: space-between;
            align-items: center;

            button {
                background: none;
                padding: 0;
                margin: 0;
                border: 0;
            }

            .icon-x {
                cursor: pointer;
            }
        }

        .modal-content {
            border: none;
            background: var(--greyColour);
            max-height: 80svh;

            @include responsive('sm') {
                max-height: 400px;
            }

            overflow-y: auto;
        }

        .modal-footer {
            border: none;
        }
    }
}
</style>
